export const iconFontAwesomeGendersMars = (
	<i className="fa-solid fa-mars"></i>
);
